import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./../app.component.css']
})
export class StartPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
